import {
    useWindowDimensions,
    View
} from "react-native";
import type RecentSectionProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    HighlightButton,
    RowCard,
    Text
} from "ncore-ui-kit";
import {
    CalendarDaysIcon,
    ChevronRightIcon,
    UsersIcon
} from "lucide-react-native";
import moment from "moment";

const RecentSection = ({
    onNavigateToMemberDetail,
    onNavigateToEventDetail,
    onNavigateToMembersList,
    onNavigateToEventsList,
    recent
}: RecentSectionProps) => {
    const {
        width
    } = useWindowDimensions();
    const isMobile = width < 992;

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const formatDate = (dateStr: string): string => {
        if(!dateStr) {
            return "";
        }

        return moment(dateStr).format("DD.MM.YYYY");
    };

    const columnMinWidth = isMobile ? "100%" : 450;

    return <View
        style={[
            stylesheet.container,
            {
                gap: spaces.spacingMd
            }
        ]}
    >
        <View
            style={[
                stylesheet.columnsContainer,
                {
                    gap: spaces.spacingLg
                }
            ]}
        >
            <View
                style={[
                    stylesheet.columnWrapper,
                    {
                        backgroundColor: colors.project.brandWhite,
                        borderRadius: radiuses.md,
                        padding: spaces.spacingLg,
                        minWidth: columnMinWidth,
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <View
                    style={stylesheet.columnHeader}
                >
                    <View
                        style={[
                            stylesheet.columnTitleContainer,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        <UsersIcon
                            color={colors.content.text.high}
                            size={20}
                        />
                        <Text
                            variant="titleMediumSize"
                        >
                            {localize("dashboard-recent-users-title")}
                        </Text>
                    </View>
                    <HighlightButton
                        onPress={onNavigateToMembersList || (() => null)}
                        title={localize("dashboard-view-all")}
                        size="small"
                        type="glass"
                    />
                </View>
                <View
                    style={[
                        stylesheet.listContainer,
                        {
                            gap: spaces.spacingSm
                        }
                    ]}
                >
                    {
                        recent.users && recent.users.length > 0 ?
                            recent.users.slice(0, 5).map((user) => {
                                return <RowCard
                                    onPress={() => {
                                        if(onNavigateToMemberDetail) {
                                            onNavigateToMemberDetail(user._id);
                                        }
                                    }}
                                    rightSubTitle={formatDate(user.createdAt)}
                                    rightSubTitleVariant="labelSmallSize"
                                    subTitleVariant="labelMediumSize"
                                    titleVariant="titleSmallSize"
                                    rightIcon={ChevronRightIcon}
                                    title={user.fullName}
                                    subTitle={user.mail}
                                    key={user._id}
                                />;
                            })
                        :
                            <View
                                style={[
                                    stylesheet.emptyContainer,
                                    {
                                        padding: spaces.spacingLg
                                    }
                                ]}
                            >
                                <Text
                                    variant="labelMediumSize"
                                    color="low"
                                >
                                    -
                                </Text>
                            </View>
                    }
                </View>
            </View>
            <View
                style={[
                    stylesheet.columnWrapper,
                    {
                        backgroundColor: colors.project.brandWhite,
                        borderRadius: radiuses.md,
                        padding: spaces.spacingLg,
                        minWidth: columnMinWidth,
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <View
                    style={stylesheet.columnHeader}
                >
                    <View
                        style={[
                            stylesheet.columnTitleContainer,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        <CalendarDaysIcon
                            color={colors.content.text.high}
                            size={20}
                        />
                        <Text
                            variant="titleMediumSize"
                        >
                            {localize("dashboard-recent-events-title")}
                        </Text>
                    </View>
                    <HighlightButton
                        onPress={onNavigateToEventsList || (() => null)}
                        title={localize("dashboard-view-all")}
                        size="small"
                        type="glass"
                    />
                </View>
                <View
                    style={[
                        stylesheet.listContainer,
                        {
                            gap: spaces.spacingSm
                        }
                    ]}
                >
                    {
                        recent.events && recent.events.length > 0 ?
                            recent.events.slice(0, 5).map((event) => {
                                return <RowCard
                                    onPress={() => {
                                        if(onNavigateToEventDetail) {
                                            onNavigateToEventDetail(event._id);
                                        }
                                    }}
                                    rightSubTitle={formatDate(event.createdAt)}
                                    subTitle={event.isActive ? "Aktif" : "-"}
                                    rightSubTitleVariant="labelSmallSize"
                                    subTitleVariant="labelMediumSize"
                                    titleVariant="titleSmallSize"
                                    rightIcon={ChevronRightIcon}
                                    title={event.title}
                                    key={event._id}
                                />;
                            })
                        :
                            <View
                                style={[
                                    stylesheet.emptyContainer,
                                    {
                                        padding: spaces.spacingLg
                                    }
                                ]}
                            >
                                <Text
                                    variant="labelMediumSize"
                                    color="low"
                                >
                                    -
                                </Text>
                            </View>
                    }
                </View>
            </View>
        </View>
    </View>;
};
export default RecentSection;
